import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class RechtsgrundLocation extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'RECHTSGRUND';
  }
}
